interface Image {
  id: number;
  fileUrl: string;
  croppedFileUrl?: string;
  name?: string;
}

export enum ICON_PLACEMENT {
  ON_IMAGE = 'onImage',
  OUTSIDE_IMAGE = 'outsideImage',
}

export interface OverlayStyles {
  overlayColor?: string;
  overlayOpacity?: number;
  blurValue?: number;
}

export interface CarouselProps {
  images: Image[];
  style?: React.CSSProperties;
  interval?: number;
  isBuilderDesktopMode?: boolean;
  iconPlacement: ICON_PLACEMENT;
  iconColor?: string;
  autoScroll?: boolean;
  MediaMap?: Map<string, any>;
  returnIndex?: (index: number) => void;
  overlayStyles?: OverlayStyles;
  initialIndex?: number;
  seoTitle?: string;
}
